import { configureStore } from '@reduxjs/toolkit'
import organizationQuestionnaireAdminReducer from './slice'

const store = configureStore({
  reducer: {
    organizationQuestionnaireAdmin: organizationQuestionnaireAdminReducer,
  },
})

export default store
